module.exports = __webpack_public_path__ + "img/save.0b69179d.svg";